window.calendarcontrol = function () {
    var instance = {
        init: function (args) {
            const el = document.getElementById(args.elid);

            instance.format.jsmask = args.format;
            if (instance.format.jsmask.includes('/'))
                instance.format.delimiter = '/';
            else if (instance.format.jsmask.includes('.'))
                instance.format.delimiter = '.';

            const mask = el.getAttribute('data-format');
            instance.format.dPos = mask.indexOf('dd'); 
            instance.format.mPos = mask.indexOf('MM');
            instance.format.yPos = mask.indexOf('yyyy');
            instance.format.mask = mask;

            el.onkeydown = onkeydown;
            el.onkeypress = onkeypress;
            el.onkeyup = onkeyup;
            el.ondrop = ondrop;
			el.onpaste = onpaste;
			el.addEventListener("focusin", function (e) {
				currentVal = el.value;
			});
			el.addEventListener("focusout", function (e) {
				if (currentVal != el.value)
					$(el).trigger('change');
			});
			if (el.hasAttribute('data-orig')) {
				el.addEventListener("change", function (e) {
                    const val = Date.parseDate(el.value, args.format);
					const orig = Date.parseDate(el.getAttribute('data-orig'), '%Y-%m-%d');
					if (!val.equalsTo(orig))
						el.style.backgroundColor = 'rgba(51, 153, 51, 0.1)';
					else
						el.style.backgroundColor = '';
				});
			}
        },
        format: {
            mask: undefined,
            jsmask: undefined,
            delimiter: undefined,
            mPos: undefined,
            dPos: undefined,
            yPos: undefined
        }
	};

	var currentVal = null;


    function onkeyup(event) {
        $(this).trigger('input');
        return true;
    }

    function ondrop(event) {
        const str = event.dataTransfer.getData("text");
        const d = Date.parseDate(str, instance.format.jsmask);
        if (!d) return false;
        $(this).trigger('input');
        return true;
    }
    function onpaste(event) {
        const str = event.clipboardData.getData("text");
        const d = Date.parseDate(str, instance.format.jsmask);
        if (!d) return false;
        $(this).trigger('input');
        return true;
    }

    function onkeydown(event) {
        const target = event.srcElement;
        const pos = getCaretPos(target);
        const len = target.value.length;

        if (event.keyCode === 46) { // del
            target.value = target.value.substring(0, pos);
            $(this).trigger('input');
            return false;
        }
        if (event.keyCode === 8 && pos !== len) { //backspace
            return false;
        }
    }

    function onkeypress(event) {
        var char = String.fromCharCode(event.charCode);
        const target = event.srcElement;

        if ('0123456789'.indexOf(char) === -1)
            return false;

        $(this).trigger('input');

        var pos = getCaretPos(target);
        const val = target.value;
        var rval = val;

        if (pos > 9)
            return false;

        var done = false;
        if (pos == 2 || pos == 5) {
            if (pos == rval.length) {
                rval = rval + instance.format.delimiter;
            }
            pos++;
        }

        if (pos == instance.format.mPos) {
            if ('01'.indexOf(char) === -1) {
                rval = rval.slice(0, pos) + '0' + char + rval.slice(pos + 2);
                pos++;
            }
            else if (pos < rval.length) {
                if (char != '0' && '012'.indexOf(rval[pos + 1]) === -1) {
                    rval = rval.slice(0, pos) + char + '0' + rval.slice(pos + 2);
                    done = true;
                }
                else if (char == '0' && rval[pos + 1] == '0') {
                    rval = rval.slice(0, pos) + char + '1' + rval.slice(pos + 2);
                    done = true;
                }
            }
        }
        else if (pos == instance.format.dPos) {
            if ('0123'.indexOf(char) === -1) {
                rval = rval.slice(0, pos) + '0' + char + rval.slice(pos + 2);
                pos++;
            }
            else if (pos < rval.length) {
                if (char == '3' && '01'.indexOf(rval[pos + 1]) === -1) {
                    rval = rval.slice(0, pos) + char + '0' + rval.slice(pos + 2);
                    done = true;
                }
                else if (char == '0' && rval[pos + 1] == '0') {
                    rval = rval.slice(0, pos) + char + '1' + rval.slice(pos + 2);
                    done = true;
                }
            }
        }

        if (!done) {
            if (pos < rval.length)
                rval = rval.slice(0, pos) + char + rval.slice(pos + 1);
            else if (pos == rval.length)
                rval = rval.slice(0, pos) + char;
            else
                return false;
        }

        const month = rval.slice(instance.format.mPos, instance.format.mPos + 2);
        const day = rval.slice(instance.format.dPos, instance.format.dPos + 2);
        const year = rval.slice(instance.format.yPos, instance.format.yPos + 4);

        if (month.length > 0 && '01'.indexOf(month[0]) === -1)
            return false;
        if (month.length > 1 && month[0] == '1' && '012'.indexOf(month[1]) === -1)
            return false;
        if (month == '00')
            return false;

        if (day.length > 0 && '0123'.indexOf(day[0]) === -1)
            return false;
        if (day.length > 1 && day[0] == '3' && '01'.indexOf(day[1]) === -1)
            return false;
        if (day.length > 0 && day[0] == '3' && month == '02')
            return false;
        const m31 = ["01", "03", "05", "07", "08", "10", "12"];
        if (day == '31' && month.length > 1 && !m31.includes(month))
            return false;
        if (day == '00')
            return false;

        if (year.length > 0 && '12'.indexOf(year[0]) === -1)
            return false;
        if (year.length > 1 && year[0] == '1' && year[1] != '9')
            return false;
        if (year.length > 1 && year[0] == '2' && '01'.indexOf(year[1]) === -1)
            return false;

        if (day == '29' && month === '02' && year.length == 4) {
            const iyear = parseInt(year, 0);
            const isLeap = ((iyear % 4 === 0) && (iyear % 100 !== 0)) || (iyear % 400 === 0);
            if (!isLeap)
                return false;
        }

        target.value = rval;

        if (pos < val.length) {
            target.setSelectionRange(pos + 1, pos + 1);
            var event = new Event('change');
            target.dispatchEvent(event);
        }

        return false;
    }

    function getCaretPos(oField) {
        // Initialize
        var iCaretPos = 0;

        // IE Support
        if (document.selection) {

            // Set focus on the element
            oField.focus();

            // To get cursor position, get empty selection range
            var oSel = document.selection.createRange();

            // Move selection start to 0 position
            oSel.moveStart('character', -oField.value.length);

            // The caret position is selection length
            iCaretPos = oSel.text.length;
        }

        // Firefox support
        else if (oField.selectionStart || oField.selectionStart === '0')
            iCaretPos = oField.selectionStart;

        // Return results
        return (iCaretPos);
    }

    return instance;
}();